import { combineReducers } from 'redux';
import registerReducer from './register-reducer';
export default combineReducers({
    register: registerReducer,
    splitTreatments: (state = {}) => state,
    mixpanelToken: (state = {}) => state,
});
